import { FileType } from "operations/schema/schema";

export const getMimeTypeFromName = (name: string) => {
  const lower = name.toLowerCase();

  if (lower.endsWith(".png")) return "image/png";
  if (lower.endsWith(".jpg") || lower.endsWith(".jpeg")) return "image/jpeg";
  if (lower.endsWith(".gif")) return "image/gif";
  if (lower.endsWith(".pdf")) return "application/pdf";
  if (lower.endsWith(".docx"))
    return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  if (lower.endsWith(".xlsx"))
    return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  return "application/octet-stream";
};

// Server files come back as raw base64; normalise to a data: URL so FilePreview can
// render a thumbnail and download them.
export const toFileType = (f: any): FileType => {
  const mimeType = getMimeTypeFromName(f.name);
  const data =
    typeof f.data === "string" && f.data.startsWith("data:")
      ? f.data
      : `data:${mimeType};base64,${f.data}`;
  return {
    id: f.id,
    name: f.name,
    description: f.description ?? "",
    data,
    size: typeof f.data === "string" ? f.data.length : 0,
    isFullSize: false,
  };
};
